// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyASHlfkcfj5bR31WdHFtxhIbnov2qUhz7o",
    authDomain: "oshop-65c4e.firebaseapp.com",
    databaseURL: "https://oshop-65c4e.firebaseio.com",
    projectId: "oshop-65c4e",
    storageBucket: "oshop-65c4e.appspot.com",
    messagingSenderId: "922611463216"    
  }
};



// WEBPACK FOOTER //
// D:/xampp_bk/htdocs/xampp/organicshop/src/environments/environment.ts